var map = {
	"./1.jpg": "6504",
	"./10.jpg": "9956",
	"./11.jpg": "5c23",
	"./12.jpg": "4cdb",
	"./2.jpg": "5e94",
	"./3.jpg": "28ef",
	"./4.jpg": "6d67",
	"./5.jpg": "be03",
	"./6.jpg": "fcf6",
	"./7.jpg": "15c0",
	"./8.jpg": "8d62",
	"./9.jpg": "c67b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7a23";